module.exports = __webpack_public_path__ + "img/smile.9be61be0.png";